import React from "react";
import PropTypes from "prop-types";

import TextField from "ui/TextField";
import IconButtonCross from "./buttons/IconButtonCross";

import SearchIcon from "assets/svg/search.svg";

const SearchComponent = (props) => {
  const {
    onClearSearch,
    value = "",
    placeholder = "Search in ...",
    ...otherProps
  } = props;

  return (
    <div className="search-bar-container">
      <SearchIcon width="20px" />
      <TextField
        id="search-field"
        className="search-field-variant"
        fullWidth
        value={value}
        placeholder={placeholder}
        {...otherProps}
      />
      {!!value.length && onClearSearch && (
        <IconButtonCross
          id="clear-search-button"
          width="20px"
          onClick={onClearSearch}
        />
      )}
    </div>
  );
};

SearchComponent.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  onClearSearch: PropTypes.func,
};

export default SearchComponent;
